<template>
    <div class="manuscript">
        <div class="main-form">
            <div class="main-form-title">上传您的设计稿</div>
            <div class="form-category">
                <Select :value="form_data.parent_product_category_id" @on-change="(value)=>change1(value, 'parent_product_category_id')">
                    <Option v-if="form_data.parent_product_category_id === 0" value="0" label="请选择"></Option>
                    <Option v-for="(v,k) in product_category_list" :key="`dpc1-${k}`" :value="v.product_category_id" :label="v.category_name_cn"></Option>
                </Select>
                <template v-if="sub_product_category_list.length > 0">
                    <Select :value="form_data.child_product_category_id" @on-change="(value)=>change1(value, 'child_product_category_id')">
                        <Option value="0" label="请选择"></Option>
                        <Option v-for="(v,k) in sub_product_category_list" :key="`dpc2-${k}`" :value="v.product_category_id" :label="v.category_name_cn"></Option>
                    </Select>
                </template>
            </div>
            <div class="main-image">
                <template v-if="main_file.raw">
                    <template v-if="util.test_image(main_file.raw)">
                        <img :src="main_file.raw" v-viewer alt="" style="width: 100%; height: 100%;object-fit:cover;"/>
                    </template>
                    <template v-else>
                        <img :src="util.get_image_icon(main_file.raw)" class="icon-doc" />
                        <a :href="main_file.raw" target="_blank" style="width: 100%;text-align: center;">{{main_file.raw_name}}</a>
                    </template>
                </template>
                <template v-else>
                    <Upload
                            :action="upload_url"
                            :data="{ dir: 'template' }"
                            :before-upload="(file)=>onBeforeUpload(file, 'image_list')"
                            :show-upload-list="false"
                            type="drag"
                            multiple
                    >
                        <div class="upload-btn">
                            <img alt="" class="icon-upload" src="@/assets/images/icon-add-3.png" style="object-fit:cover;"/>
                            <p>支持图片文件上传，jpg,png,psd,cdr等</p>
                        </div>
                    </Upload>
                </template>
            </div>
            <div class="image-list">
                <div class="image-item" v-for="(v, k) in form_data.image_list"
                    :key="`i` + k"
                    draggable
                    @dragstart="handleDragStart($event, k)"
                    @dragover.prevent
                    @drop="handleDrop($event, k)" @click.prevent.stop="set_image(v)">
                    <template v-if="typeof(v) === 'string'">
                        <img :src="v" alt="" style="object-fit:cover;" />
                    </template>
                    <template v-else>
                        <img v-if="util.test_image(v.raw)" :src="v.raw" alt="" style="object-fit:cover;" />
                        <img v-else :src="util.get_image_icon(v.raw)" alt="" style="object-fit:cover;" />
                    </template>
                    <img alt="" class="icon-close" src="@/assets/images/icon-close@2x.png" @click.prevent.stop="del_img(k)"/>
                </div>
                <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    :before-upload="(file)=>onBeforeUpload(file, 'image_list')"
                    :show-upload-list="false"
                    multiple
                >
                    <div class="image-item">
                        <span>+</span>
                        <span>添加</span>
                    </div>
                </Upload>
            </div>
            <div class="main-form-title">一版多款设置</div>
            <div class="multiple-wrap">
                <img v-if="form_data.is_multiple" src="@/assets/images/design/icon-checkbox-selected.png" alt="" class="cursor icon-check" @click="toggle_multi">
                <img v-else src="@/assets/images/design/icon-check-no.png" alt="" class="cursor icon-check" @click="toggle_multi">
                <span>同一个版型制作多个款式</span>
            </div>
            <div class="multiple-form" v-if="form_data.is_multiple">
                <div class="multiple-tips">请为每个款式备注名称，以便后期下单</div>
                <div class="multiple-form-body">
                    <div class="multiple-item" v-for="(item, k) in form_data.children" :key="k">
                        <div class="item-label">款式{{ k+1 }}</div>
                        <Input placeholder="请输入款式名称" :value="form_data.children[k].name" @on-change="input2($event, 'children', k, 'name')"></Input>
                        <img src="@/assets/images/design/icon-del-2.png" alt="" class="btn-del" @click="del_child(k)">
                    </div>
                    <div class="btn-add" @click="add_child">添加</div>
                </div>
            </div>
            <div class="main-form-title mt-40">款式说明</div>
            <textarea placeholder="请输入款式说明" :value="form_data.description" class="main-form-textarea" @input="input1($event, 'description')"></textarea>
        </div>
        <div class="main-content">
            <lesson></lesson>
        </div>
    </div>
</template>
<script>
import { uploadFileToOSS } from "@/utils/oss";
import util from '@/utils/util';
import { mapState } from 'vuex';
import Lesson from "./Lesson.vue";

    export default {
        name: "Manuscript",
        data() {
            return {
                util: util,
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                sub_product_category_list: [],
                is_popup_show: false,
                main_file: {
                    raw: "",
                    raw_name: ""
                },
                curr_package_detail:[]
            }
        },
        components: {
            Lesson
        },
        watch: {
            "form_data.parent_product_category_id": {
                handler(newVal, oldVal) {
                    console.log('base', newVal, oldVal)
                    if (newVal > 0) {
                        let obj = this.product_category_list.find((v) => v.product_category_id === newVal);
                        this.sub_product_category_list = obj ? obj.children : [];
                        if (oldVal > 0) {
                            this.$store.commit("design/update_common", {key: 'child_product_category_id', value: 0})
                        }
                    }
                },
                immediate: true, // 立即执行一次handler以初始化数据
            },
            "form_data.image": {
                handler(newVal, oldVal) {
                    if(newVal) {
                        this.main_file = {
                            raw: newVal,
                            raw_name: ''
                        }
                    } else if(this.form_data.image_list && this.form_data.image_list.length > 0) {
                        const firstImage = this.form_data.image_list[0];
                        if (typeof firstImage === 'object') {
                            this.main_file = firstImage;
                        } else {
                            this.main_file = {
                                raw: firstImage,
                                raw_name: ''
                            };
                        }
                    }
                },
                immediate: true, // 组件初始化时立即执行
            },
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                is_lesson_show: (state) => state.design.is_lesson_show,
                product_category_list: (state) => state.design.product_category_list,
            }),

        },
        mounted(){
            //防止在点开弹窗以后直接刷新页面导致再次进入弹窗不关闭的问题
            this.$store.commit('design/hide_lesson_popup');
        },
        methods: {
            input2($event, field, k, child_field) {
                const newValue = $event.target.value;
                // console.log('event',$event,'newVal',newValue);
                const originalItem = this.form_data[field][k];
                let updatedItem = {...originalItem, [child_field]: newValue}
                this.$store.commit('design/arr_update_one', {key: field, index: k, value:updatedItem})
            },
            del_child(k) {
                this.$store.commit('design/arr_remove_one', {key: 'children', index: k})
            },
            add_child() {
                let object = {
                    key: util.uuid(),
                    name: ''
                }
                this.$store.commit('design/arr_push_one', {key: 'children', value: object})
            },
            toggle_multi() {
                this.$store.commit('design/update_common',{key:'is_multiple',value:!this.form_data.is_multiple})
            },
            set_image(obj) {
                if(typeof obj === 'object') {
                    this.main_file = obj;
                    // 同步更新 store 中的 image 字段
                    this.$store.commit('design/update_common', {key: 'image', value: obj.raw});
                } else {
                    this.main_file = {
                        raw: obj,
                        raw_name: ''
                    };
                    // 同步更新 store 中的 image 字段
                    this.$store.commit('design/update_common', {key: 'image', value: obj});
                }
            },
            change1(value, field) {
                switch(field){
                    case 'parent_product_category_id':{
                        const find_index = this.product_category_list.findIndex((item)=>Number(item.product_category_id) === Number(value));
                        if(find_index != -1){
                            this.curr_package_detail = this.product_category_list[find_index].package_detail || [];
                            this.$store.commit('design/update_common',{key:'package_detail',value:this.curr_package_detail})
                        }
                        break;
                    }
                    case 'child_product_category_id':{
                        const find_index = this.sub_product_category_list.findIndex((item)=>Number(item.product_category_id) === Number(value));
                        if(find_index != -1){
                            if(this.sub_product_category_list[find_index].package_detail && this.sub_product_category_list[find_index].package_detail.length>0){
                                this.package_detail = this.sub_product_category_list[find_index].package_detail;
                                this.$store.commit('design/update_common',{key:'package_detail',value:this.curr_package_detail})
                            }
                        }
                        break;
                    }

                }
                console.log('package_detail',this.form_data.package_detail);
                this.$store.commit('design/update_common', {key: field, value: parseInt(value)})
            },
            input1($event, field) {
                this.$store.commit('design/update_common', {key: field, value: $event.target.value})
            },
            handleDragStart(event, draggedIndex) {
                event.dataTransfer.setData("draggedIndex", draggedIndex);
            },
            handleDrop(event, targetIndex) {
                event.preventDefault();
                const draggedIndex = event.dataTransfer.getData("draggedIndex");
                if (draggedIndex === targetIndex) return;
                let image_list = this.form_data.image_list
                const draggedItem = image_list.splice(draggedIndex, 1)[0];
                image_list.splice(targetIndex, 0, draggedItem);
                this.$store.commit('design/update_common', {key: 'image_list', value: image_list})
            },
            del_img(k) {
                this.$store.commit('design/arr_remove_one', {key: 'image_list', index: k})
                let len = this.form_data.image_list.length;
                console.log(111, len)
                if (len === 0) {
                    this.main_file = {raw: '', raw_name: ''}
                } else {
                    if(typeof this.form_data.image_list[0] === 'object') {
                        this.main_file = this.form_data.image_list[0]
                    } else {
                        this.main_file = {
                            raw: this.form_data.image_list[0],
                            raw_name: ''
                        }
                    }
                }
            },
            onBeforeUpload(file, field) {
                if(this.form_data.image_list.length >= 15) {
                    this.$layer.msg(`最多可添加15张设计图`)
                    return
                }
                uploadFileToOSS(file, 'template').then(url => {
                    if (field === "image_list") {
                        let object = {}
                        object.raw = url;
                        object.raw_name = file.name;
                        this.$store.commit('design/arr_push_one', {key: 'image_list', value: object})
                        if(this.form_data.image_list.length === 1) {
                            this.main_file = object;
                            // 如果是第一个图片，同步到 form_data.image
                            this.$store.commit('design/update_common', {key: 'image', value: url});
                        }
                    }
                })
                return false;
            },
        }
    }
</script>
<style lang="scss" scoped>
.manuscript{
    width:100%;
    height:100%;
    display:flex;
    .main-form{
        width:488px;
        height:100%;
        overflow-y:auto;
        padding:30px;
        background:#fff;
        border-right:1px solid #f0f0f0;
        &::-webkit-scrollbar{
            display:none;
        }
        .main-form-title{
            color:#000;
            font-size:18px;
            display:flex;
            align-items:center;
            column-gap:10px;
            line-height:18px;
            font-weight:bold;
            &::before{
                content:"";
                width:2px;
                height:18px;
                line-height:18px;
                background:#000;
            }
            &.mt-40{
                margin-top:40px;
            }
        }
        .form-category{
            width:100%;
            display:flex;
            column-gap:10px;
            align-items:center;
            margin-top:30px;
        }

        .main-image{
            width:100%;
            height:421px;
            margin-top:25px;
            border-radius: 5px;
            border: 1px dashed #B3B3B3;
            &:hover{
                border:1px dashed skyblue;
            }
            .upload-btn{
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                width:100%;
                height:100%;
                .icon-upload {
                    width: 52px;
                    height: 60px;
                }
                p {
                    width: 100%;
                    color: #4d4f52;
                    font-size: 14px;
                    margin-top: 26px;
                    text-align: center;
                }
            }
            ::v-deep .ivu-upload{
                width:100%;
                height:100%;
                border:none;
            }
            .icon-doc {
                width: 50px;
                height: 50px;
            }
        }
        .image-list{
            width:100%;
            display:flex;
            align-items:center;
            column-gap:10px;
            flex-wrap:wrap;
            margin-top:20px;
            margin-bottom:40px;
            .image-item{
                width:60px;
                height:60px;
                border:1px solid #b3b3b3;
                border-radius:5px;
                display:flex;
                align-items:center;
                justify-content:center;
                flex-direction:column;
                row-gap:6px;
                cursor:pointer;
                position:relative;
                overflow:hidden;
                span {
                    width: 60px;
                    height: 15px;
                    text-align: center;
                    &:first-child{
                        font-size:20px;
                    }
                    &:last-child{
                        font-size:12px;
                    }
                }
                .icon-close {
                    position: absolute;
                    width: 15px;
                    height: 15px;
                    top: 0;
                    right: 0;
                    z-index:10;
                }
                img{
                    width:100%;
                    height:100%;
                }
            }
        }
        .multiple-wrap {
            display: flex;
            align-items: center;
            margin: 10px 0;
            .icon-check {
                width: 20px;
                height: 20px;
            }
            span {
                margin: 0 5px;
            }
        }
        .multiple-form{
            width:100%;
            border:1px solid #d1d1d1;
            padding:15px 15px 20px 15px;
            .multiple-tips{
                color:#999;
                font-size:14px;
            }
            .multiple-form-body{
                width:100%;
                background:#fff;
                padding:20px 11px 20px 14px;
                display:flex;
                flex-direction:column;
                row-gap:10px;
                .multiple-item{
                    display: flex;
                    align-items:center;
                    column-gap:10px;
                    .item-label{
                        color:#4d4d4d;
                        font-size:14px;
                        flex-shrink:0;
                    }
                    .btn-del{
                        width:24px;
                        height:24px;
                        cursor:pointer;
                    }
                }
                .btn-add{
                    width:100%;
                    height: 35px;
                    line-height: 35px;
                    color: #666666;
                    font-size: 14px;
                    text-align: center;
                    margin: 10px 0;
                    border-radius: 10px;
                    border: 1px solid #ccc;
                    cursor:pointer;
                }
            }
        }
        .main-form-textarea{
           resize:none;
           border:1px solid #d1d1d1;
           border-radius:5px;
           margin-top:16px;
           width:100%;
           height:180px;
           padding:15px;
           background:#f8f9fc;
           outline:none;
        }
    }
    .main-content{
        flex:1;
        height:100%;
        display:flex;
        align-items:center;
        justify-content:center;
    }
}
</style>
